import { EmployeesExclude } from './EmployeesExclude'

export const Utilities = () => {
  return <EmployeesExclude />
}
